/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import React from 'react';
import { SdsDivProps } from '../Component.props';
import { DropdownMenuProps } from '../Dropdown';
import { NavigationSection } from '../SideNav';

/**
 * The props for `<Toolbar />`.
 */
export interface ToolbarProps extends SdsDivProps {
  /**
   * Client name.
   */
  clientName?: React.ReactNode;

  /**
   * The toolbar logo.
   */
  logo: JSX.Element;

  /**
   * Menu sections.
   */
  menuSections: Array<NavigationSection>;

  /**
   * Show the side nav launcher on Tablet devices.
   */
  showTabletNavigation?: boolean;

  /**
   * The capability switcher.
   */
  switcher?: React.ReactNode;

  /**
   * Text to display next to the logo.
   */
  text: string;

  /**
   * Toolbar content.
   */
  toolbarContent?: React.ReactNode;

  /**
   * Toolbar dropdown menus.
   */
  toolbarMenus?: Array<DropdownMenuProps>;

  /**
   * Toolbar user menu.
   */
  toolbarUser?: React.ReactNode;
}

/**
 * The default prop values for `<Toolbar />`.
 */
export const toolbarDefaults = {
  showTabletNavigation: false,
  toolbarMenus: [],
};
